<template>
  <div
    class="vendasFalhadas"
    v-loading="loadingPage"
    style="padding: 10px; background: #fff; border-radius: 4px; height: 520px"
  >
    <h3 style="text-align: left; margin-bottom: 1rem">Vendas Falhadas</h3>
    <el-row style="display: flex; align-items: center">
      <el-col :lg="12">
        <h4><strong>Total: </strong> R${{ total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</h4>
      </el-col>
      <el-col :lg="12">
        <apexchart
          height="180"
          type="pie"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </el-col>
    </el-row>
    <div>
      <el-row v-for="item in list" :key="item.name" class="row-pie">
        <el-col :lg="10"> {{ item.name }} </el-col>
        <el-col :lg="8">
          R$
          {{ item.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
        </el-col>

        <el-progress :percentage="item.percent" :color="cor1"></el-progress>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getTransations } from "@/app/domains/Financial/services";
import { makeErrorFilds } from "@/app/plugins/utils";
import { getSellFails } from "@/app/domains/Core/services";
export default {
  name: "ProgressaoTPV",
  props: {
    querySearch: {
      type: [],
      default: "",
    },
  },
  data() {
    return {
      cor1: "#304758",
      cor2: "#ff6666",
      chartOptions: {
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val) {
              return (
                "R$ " +
                Intl.NumberFormat("pt-BR", {
                  style: "decimal",
                  currency: "BRL",
                  minimumFractionDigits: 0,
                }).format(val) 
                
              );
            },
          },
        },
        chart: {
          id: "vuechart-example",
          type: "pie",
        },
        labels: ["Crédito", "Debito"],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return (
              "" +
              Intl.NumberFormat("pt-BR", {
                style: "decimal",
                currency: "BRL",
                minimumFractionDigits: 0,
              }).format(val) +
              "%"
            );
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
          },
        },
      },
      series: [],
      total: 0,
      list: [],
    };
  },
  computed: {
    ...mapGetters("Auth", ["getColorTheme"]),
  },
  watch: {
    querySearch: async function (query) {
      await this.init(query, true);
    },
  },
  methods: {
    async init(query = "") {
      if (this.getColorTheme.colorPrimary != null) {
        this.cor1 = this.getColorTheme.colorPrimary;
      }
      if (this.getColorTheme.colorSecondary != null) {
        this.cor2 = this.getColorTheme.colorSecondary;
      }
      this.$set(this.chartOptions, "colors", [
        this.getColorTheme.colorPrimary,
        "#ff6666",
      ]);
      this.loadingPage = true;
      try {
        // let queryP = "?init_date=" + query[0] + "&finish_date=" + query[1];
        let queryP = "";
        let response = await getSellFails(queryP);
        this.list = response.data.list;
        this.total = response.data.chart.total;
        this.series = [
          response.data.chart.credit,
          response.data.chart.debit,
        ];
      } catch (e) {
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
    formatReal(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(value);
    },
  },

  async beforeMount() {
    await this.init(this.querySearch);
  },
};
</script>
